module.exports = __webpack_public_path__ + "static/media/blingV3_8.2afc5695.png";